import { render, staticRenderFns } from "./classCheckDetail.vue?vue&type=template&id=067bd6ce"
import script from "./classCheckDetail.vue?vue&type=script&lang=js"
export * from "./classCheckDetail.vue?vue&type=script&lang=js"
import style0 from "./classCheckDetail.vue?vue&type=style&index=0&id=067bd6ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports